import { Button, InputLabel, TextField } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import { ISelectOptions } from '../../dynamicForms/interfaces/IDynamicFormRow';
import CloseIcon from '@material-ui/icons/Close';
import DraggableList, { ICard } from '../draggable-list';
import './draggableExtraItems.css';
import { InfoIconToolTip } from '../UI/InfoIconToolTip/InfoIconToolTip';
import { FilterOptionsState, Skeleton } from '@material-ui/lab';
import FormElement from '../../dynamicForms/FormElement';
import ICommonFormProps from '../../dynamicForms/interfaces/ICommonFormProps';
import { useTranslation } from 'react-i18next';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { isValue } from '../../dynamicForms/utils';

export function FormDnDList(props: ICommonFormProps) {
    const [selectedData, setSelectedData] = useState<any[]>([]);

    const [selectOpsData, setSelectOpsData] = useState<ISelectOptions[] | any[]>([]);
    useEffect(() => {
        if (props.value) {
            setSelectedData(props.value);
        }
        //eslint-disable-next-line
    }, [props.value]);
    useEffect(() => {
        if (props.formProps?.selectOptions) {
            setSelectOpsData(props.formProps?.selectOptions || []);
        }
        // eslint-disable-next-line
    }, [props.formProps?.selectOptions]);
    useEffect(() => {
        if (props.setValue && isValue(selectedData)) {
            props.setValue(props.keyName, selectedData, { shouldDirty: true });
        }
        // eslint-disable-next-line
    }, [selectedData]);

    function onChangeSelect(event: any, value: any) {
        if (props.disabled) {
            return;
        }
        const id = value.id;
        /**does entry exist */
        const entry = selectOpsData?.find((extra) => extra.id === id);
        if (!entry) {
            return;
        }
        /**Has the entry already been selected */
        const isSelected = selectedData.find((sD) => sD.id === id);
        if (isSelected) {
            return;
        }
        setSelectedData((prevState) => {
            prevState.push(value);
            return [...prevState];
        });
    }
    function onClickButton(cardData: ICard) {
        if (props.disabled) {
            return;
        }
        const index = selectedData.findIndex((sD) => sD.id === cardData.id);
        if (!index && index !== 0) {
            return;
        }
        setSelectedData((prevState) => {
            prevState.splice(index, 1);
            return [...prevState];
        });
    }
    return (
        <FormElement {...props}>
            <div>
                {!props.formProps?.selectOptions && props.formProps?.selectOptions?.length === 0 ? (
                    <Skeleton />
                ) : (
                    <>
                        <SelectComponent
                            infoMessage={props.formProps?.infoMessage}
                            placeHolder={props.formProps?.placeholder!}
                            disabled={props.disabled!}
                            onChange={onChangeSelect}
                            selectOptions={selectOpsData}
                            label={props.label}
                            labelKey={props.formProps?.selectKeyName}
                            selectedData={selectedData}
                        />
                        {selectedData.length > 0 && (
                            <div className={'dnd-list-parent'}>
                                <DraggableList
                                    nameFieldIndex={1}
                                    className="draggable-extra-items"
                                    list={selectedData}
                                    fields={[
                                        {
                                            key: 'name_public',
                                        },
                                        {
                                            key: 'remove',
                                            modifier: (enabled: boolean, cardData: any) => {
                                                return (
                                                    !props.disabled && (
                                                        <Button onClick={() => onClickButton(cardData)}>
                                                            {' '}
                                                            <CloseIcon />
                                                        </Button>
                                                    )
                                                );
                                            },
                                        },
                                    ]}
                                    id={'productlist'}
                                    onDrop={(data: any) => setSelectedData(data)}
                                />
                            </div>
                        )}
                    </>
                )}
            </div>
        </FormElement>
    );
}

interface ISelectProps {
    selectOptions: ISelectOptions[];
    onChange: (event: any, value: any) => void;
    label: string;
    infoMessage: string;
    placeHolder: string;
    labelKey?: string;
    disabled?: boolean;
    selectedData: any[];
}
const filter = createFilterOptions();

function SelectComponent({
    selectOptions,
    onChange,
    label,
    infoMessage,
    placeHolder,
    selectedData,
    labelKey = 'name',
    disabled = false,
}: ISelectProps): JSX.Element {
    const { t } = useTranslation();
    const textBoxRef = useRef();
    const [value, setValue] = useState('');
    function onSelect(ev: any, value: any) {
        if (value) {
            onChange(ev, value);
        }
        setValue('');
    }

    function removeValue(params: any) {
        let newObj = {
            ...params,
        };
        delete newObj.inputProps.value;
        return newObj;
    }
    return (
        <>
            <div style={{ marginBottom: '1rem' }}>
                <InputLabel id="select-item">
                    {t(label)}
                    <span style={{ padding: '0.3rem' }}>
                        {' '}
                        <InfoIconToolTip infoMessage={infoMessage} />
                    </span>
                </InputLabel>
            </div>
            <Autocomplete
                noOptionsText={t('misc.noOptions')}
                disabled={disabled}
                onChange={onSelect}
                options={selectOptions || []}
                getOptionLabel={(option: any) => option[labelKey]}
                filterOptions={(options: any[], params: FilterOptionsState<any>) => {
                    const filtered = filter(options, params);
                    return filtered;
                }}
                getOptionDisabled={(option: any) => {
                    const index = selectedData.findIndex((item) => item.id === option?.id);
                    return index > -1 ? true : false;
                }}
                onInputChange={(event, newInput, reason) => {
                    if (reason === 'reset') {
                        setValue('');
                        return;
                    } else {
                        setValue(newInput);
                    }
                }}
                value={null}
                inputValue={value}
                defaultValue={''}
                renderInput={(params) => (
                    <TextField
                        {...removeValue(params)}
                        inputRef={textBoxRef}
                        value={value}
                        name={'select-dnd'}
                        variant="outlined"
                        disabled={disabled}
                        placeholder={t(placeHolder)}
                    />
                )}
            />
        </>
    );
}
